import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { ISendSms, ISendSmsResponse, ISendSMSLogs, ISendSMSLogsResponse, IRecieveSMSListResponse, IMarkAsReadInput, IMarkAsReadResponse, ISendEmailInput, ISendEmailOutput, IEmailBodyInput, ISendEmailOutputModel } from 'src/app/Shared/interface2';
import {AppService} from '../app.service';

@Injectable({
    providedIn: 'root'
})

export class twoWayService {
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    private baseURL = this.appService.config.apiBaseUrl;


    SendSms(sendsmsInput: ISendSms): Observable<ISendSmsResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/SMS/SendSMS`;
        return this.http.post<ISendSmsResponse>(url, sendsmsInput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getSmsLogs(sendsmsLogInput: ISendSMSLogs): Observable<ISendSMSLogsResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/SMSOperations/GetSMSLogs`;
        return this.http.post<ISendSMSLogsResponse>(url, sendsmsLogInput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetsmsCountservice(FacId: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/SMSOperations/GetReceivedMessageCount?facilityId=${FacId}`,
        { observe: 'response' }).pipe(
            map(res => {
                return res.body as any;
            }),
            catchError(this.handleError)
        );
    }

    GetIncomingSMSList(FacId: number): Observable<IRecieveSMSListResponse> {
        return this.http.get<IRecieveSMSListResponse>(
            `${this.baseURL}/SMSOperations/GetReceivedMessageList?facilityId=${FacId}`,
        { observe: 'response' }).pipe(
            map(res => {
                return res.body as IRecieveSMSListResponse;
            }),
            catchError(this.handleError)
        );
    }

    markAsread(markReadInput: IMarkAsReadInput): Observable<IMarkAsReadResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/SMSOperations/MarkSmsAsRead`;
        debugger;
        return this.http.post<IMarkAsReadResponse>(url, markReadInput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    deleteMess(markReadInput: IMarkAsReadInput): Observable<IMarkAsReadResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/SMSOperations/MarkNotificationRemoved`;
        return this.http.post<IMarkAsReadResponse>(url, markReadInput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getBody(emailbodyinput: IEmailBodyInput): Observable<ISendEmailOutputModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/EmailAndSMS/GetBatchFollowUpEmail`;
        return this.http.post<ISendEmailOutputModel>(url, emailbodyinput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    sendEmail(emailinput: ISendEmailInput[]): Observable<ISendEmailOutput[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Email/SendEmail`;
        return this.http.post<ISendEmailOutput[]>(url, emailinput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }



    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
